import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormLayout } from '@/components/layout';
import { Checkbox } from '@/components/ui/inputs/Checkbox';
import { Selector } from '@/components/ui/inputs/selector/Selector';
import type { SelectorOption } from '@/components/ui/inputs/selector/Selector.types';
import type { AttendanceConfigForm } from '@/schemas/attendance/attendanceConfiguration.schema';


interface AttendanceConfigurationCalculationFormProps {
  form: AttendanceConfigForm;
  halfDayAbsenteeismOptions: SelectorOption[];
}

const handleSubmit = (event: React.FormEvent) => {
  event.preventDefault();
};

export const AttendanceConfigurationCalculationForm: React.FC<
  AttendanceConfigurationCalculationFormProps
> = ({
  form,
  halfDayAbsenteeismOptions,
}) => {
  const { t: translate } = useTranslation('attendance');
  const fields = translate('configuration.fields', { returnObjects: true }) as Record<string, string>;
  const sections = translate('configuration.sections', { returnObjects: true }) as Record<string, string>;
  const tooltips = translate('configuration.tooltips', { returnObjects: true }) as Record<string, string>;
  const { watch, setValue } = form;

  return (
    <FormLayout onSubmit={handleSubmit} columns={4}>
      {/* Sección Cortes Mensuales */}
      <FormLayout.Section title={sections.monthlyCuts}>
        <Checkbox
          label={fields.multiCutsSameMonth}
          tooltipText={tooltips.multiCutsSameMonth}
          checked={watch('multiCutsSameMonth')}
          onChange={(checked) => setValue('multiCutsSameMonth', checked, { shouldDirty: true })}
        />
        <Checkbox
          label={fields.sendByDateConcept}
          tooltipText={tooltips.sendByDateConcept}
          checked={watch('sendByDateConcept')}
          onChange={(checked) => setValue('sendByDateConcept', checked, { shouldDirty: true })}
        />
        <Checkbox
          label={fields.groupClosure}
          tooltipText={tooltips.groupClosure}
          checked={watch('groupClosure')}
          onChange={(checked) => setValue('groupClosure', checked, { shouldDirty: true })}
        />
      </FormLayout.Section>

      {/* Sección Condiciones para Cálculo */}
      <FormLayout.Section title={sections.calculationConditions}>
        <Checkbox
          label={fields.holidaysAsWorkdays}
          tooltipText={tooltips.holidaysAsWorkdays}
          checked={watch('holidaysAsWorkdays')}
          onChange={(checked) => setValue('holidaysAsWorkdays', checked, { shouldDirty: true })}
        />
        <Checkbox
          label={fields.art38IgnoreHolidays}
          tooltipText={tooltips.art38IgnoreHolidays}
          checked={watch('art38IgnoreHolidays')}
          onChange={(checked) => setValue('art38IgnoreHolidays', checked, { shouldDirty: true })}
        />
        <Checkbox
          label={fields.calendarScheduleManagement}
          tooltipText={tooltips.calendarScheduleManagement}
          checked={watch('calendarScheduleManagement')}
          onChange={(checked) => setValue('calendarScheduleManagement', checked, { shouldDirty: true })}
        />
        <Selector
          label={fields.halfDayAbsenteeism}
          tooltipText={tooltips.halfDayAbsenteeism}
          options={halfDayAbsenteeismOptions}
          value={watch('halfDayAbsenteeism') || undefined}
          onChange={(value) => setValue('halfDayAbsenteeism', value as string, { shouldDirty: true })}
        />
        <Checkbox
          label={fields.calculationByContractEnd}
          checked={watch('calculationByContractEnd')}
          onChange={(checked) => setValue('calculationByContractEnd', checked, { shouldDirty: true })}
        />
      </FormLayout.Section>
    </FormLayout>
  );
};
